import { isWxMiniprogram, JumpPage, isSandbox,} from '@/common/utils/tools'
import {MP_PLATFORM} from '@/common/utils/const'
// 小程序跳转优惠券列表
// 获取系统版本
export let getOsVersion = function() {
    var u = navigator.userAgent,
        version = "";
    if (u.indexOf("Mac OS X") > -1) {
        // ios
        var regStr_saf = /OS [\d._]*/gi;
        var verinfo = u.match(regStr_saf);
        version =
            "IOS" +
            (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
    } else if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
        // android
        version =
            "Android" +
            u.substr(
                u.indexOf("Android") + 8,
                u.indexOf(";", u.indexOf("Android")) - u.indexOf("Android") - 8
            );
    } else if (u.indexOf("BB10") > -1) {
        // 黑莓bb10系统
        version =
            "blackberry" +
            u.substr(
                u.indexOf("BB10") + 5,
                u.indexOf(";", u.indexOf("BB10")) - u.indexOf("BB10") - 5
            );
    } else if (u.indexOf("IEMobile") > -1) {
        // windows phone
        version =
            "winphone" +
            u.substr(
                u.indexOf("IEMobile") + 9,
                u.indexOf(";", u.indexOf("IEMobile")) -
                    u.indexOf("IEMobile") -
                    9
            );
    } else {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf("windows nt 5.0") > -1) {
            version = "Windows 2000";
        } else if (
            userAgent.indexOf("windows nt 5.1") > -1 ||
            userAgent.indexOf("windows nt 5.2") > -1
        ) {
            version = "Windows XP";
        } else if (userAgent.indexOf("windows nt 6.0") > -1) {
            version = "Windows Vista";
        } else if (
            userAgent.indexOf("windows nt 6.1") > -1 ||
            userAgent.indexOf("windows 7") > -1
        ) {
            version = "Windows 7";
        } else if (
            userAgent.indexOf("windows nt 6.2") > -1 ||
            userAgent.indexOf("windows 8") > -1
        ) {
            version = "Windows 8";
        } else if (userAgent.indexOf("windows nt 6.3") > -1) {
            version = "Windows 8.1";
        } else if (
            userAgent.indexOf("windows nt 6.2") > -1 ||
            userAgent.indexOf("windows nt 10.0") > -1
        ) {
            version = "Windows 10";
        } else {
            version = "Unknown";
        }
    }
    return version;
};

/**
 * @param {Number} val 秒数
 * @description 将秒数转为时分秒格式
 */
export const formatDuration = (val = 0) => {
    let days = Math.floor(val / 86400);
    let hours = Math.floor((val % 86400) / 3600);
    let minutes = Math.floor((val % 3600) / 60);
    let seconds = Math.floor(val % 60);
    let str = "";
    if (days > 0) {
        str += `${days}天 `;
    }
    str += [hours, minutes, seconds].join(":");
    return str;
};

/**
 * @name: 获取N天后的初始时间戳
 * @param { Number } afterDay 跟今天相隔的天数，默认为0
 */
export function getDayStartTimeStamp(afterDay = 0) {
    let timeStamp =
        (new Date().setHours(0, 0, 0, 0) as any) + afterDay * 86400000;
    return timeStamp;
}

/**
 * 设置同类多实例的响应缓存（防止缓存内存过大的处理）
 * @param classKey 缓存的一个类型
 * @param key 该缓存类型的一个实例
 * @param val 该缓存实例的值
 * @param expire 该缓存实例的过期时间戳（秒级）
 */
export const setClassStorage = (
    classKey = "",
    key = "",
    val = "",
    expire = Math.floor(Date.now() / 1000) + 7 * 86400
) => {
    console.log(`设置同类多实例的响应缓存:: ${key}:${val}`);
    console.log(`过期时间`, new Date(expire * 1000));
    let getItem = localStorage.getItem(classKey) || "{}";
    let obj = JSON.parse(getItem);
    obj[key] = {
        val,
        e: expire,
    };
    if (val === null) {
        delete obj[key];
    }
    let nowTime = Math.floor(Date.now() / 1000);
    let newObj = {};
    Object.keys(obj).forEach((objKey) => {
        let item = obj[objKey];
        if (item.e > nowTime) {
            newObj[objKey] = item;
        }
    });
    console.log(
        `%c类${classKey}当前的缓存值`,
        "color: orange",
        JSON.stringify(newObj, null, "\t")
    );

    localStorage.setItem(classKey, JSON.stringify(newObj));
};
/**
 * 获取同类多实例的响应缓存
 * @param classKey 缓存的一个类型
 * @param key 该缓存类型的一个实例
 * @return Object {val: key的缓存值, e: key的过期时间戳}
 */
export const getClassStorage = (classKey = "", key = "") => {
    let getItem = localStorage.getItem(classKey) || "{}";

    let obj = JSON.parse(getItem);
    let res = {};
    if (obj && obj[key] && obj[key].e > Math.floor(Date.now() / 1000)) {
        res = obj[key];
    }
    console.log(
        `%c类${classKey}下实例${key}的缓存:`,
        `color: ${(res as any).e ? "green" : "red"};`,
        JSON.stringify(res, null, "\t"),
        (res as any).e
            ? `\n剩余过期时间:\n${formatDuration(
                  Math.floor((res as any).e - Date.now() / 1000)
              )}`
            : ``
    );
    return res;
};

export function wxMinigoToCouponList(){
    if(isWxMiniprogram){
        let url = '';
        const platform = localStorage.getItem("platform") || "";
        switch (String(platform)) {
          case MP_PLATFORM.TingZhi:
          case MP_PLATFORM.YiQiWen:
          case MP_PLATFORM.YiQiMiaoSuan:
          case MP_PLATFORM.TingZhiWenDa:
          case MP_PLATFORM.MaoErQianShu:
          case MP_PLATFORM.XingMiaoXingZuo:
          case MP_PLATFORM.YiQiQingShu:
          case MP_PLATFORM.NiWeiKaFei:
            url = '/packageA/pages/me/coupon';
            break;
          case MP_PLATFORM.YiQiCeSuan:
          case MP_PLATFORM.TingZhiCeSuan:
          case MP_PLATFORM.TingZhiMiaoSuan:
          case MP_PLATFORM.YiQiZiXun:
          case MP_PLATFORM.TingZhiWenWen:
            url = '/packageB/pages/me/coupon';
            break;
          case MP_PLATFORM.TingZhiZiXun:
            url = '/pages/me/coupon';
            break;
          default:
            break;
        }
        debugger
        JumpPage(url);
    }

}
